module.exports = __webpack_public_path__ + "static/img/check_select.f12dcf82.svg";